// Newsletter: AJAX form submit + modal trigger.
// Endpoint defined in inc/newsletter.php (action=haegoziya_subscribe).

const SEEN_KEY = 'haegoziya_nl_dismissed';
const SUCCESS_HOLD_MS = 1600;       // how long the success message stays before the modal auto-closes

let modalEl = null;                 // hoisted so onSubmit can close it on success

function init() {
    modalEl = document.querySelector('[data-newsletter-modal]');

    const forms = document.querySelectorAll('[data-newsletter-form]');
    forms.forEach((form) => form.addEventListener('submit', onSubmit));

    setupModal();
}

function isFormInModal(form) {
    return modalEl && modalEl.contains(form);
}

async function onSubmit(event) {
    event.preventDefault();
    const form = event.currentTarget;
    const feedback = form.querySelector('[data-newsletter-feedback]');
    const data = new FormData(form);
    data.append('action', 'haegoziya_subscribe');
    data.append('nonce', window.HAEGOZIYA?.newsletterNonce || '');

    feedback.className = 'newsletter-form__feedback';
    feedback.textContent = '';

    try {
        const res = await fetch(window.HAEGOZIYA.ajaxUrl, {
            method: 'POST',
            body: data,
            credentials: 'same-origin',
        });
        const json = await res.json();
        if (json.success) {
            feedback.classList.add('is-success');
            feedback.textContent = json.data?.message || 'Thanks!';
            form.reset();
            localStorage.setItem(SEEN_KEY, '1');

            // Auto-dismiss the modal a beat after success so the user
            // sees the confirmation message before it vanishes. Only
            // applies to the modal form — the footer form stays put.
            if (isFormInModal(form)) {
                setTimeout(closeModal, SUCCESS_HOLD_MS);
            }
        } else {
            feedback.classList.add('is-error');
            feedback.textContent = json.data?.message || 'Please try again.';
        }
    } catch (err) {
        feedback.classList.add('is-error');
        feedback.textContent = 'Network error — try again.';
    }
}

function openModal() {
    if (!modalEl) return;
    modalEl.hidden = false;
    modalEl.classList.add('is-open');
}

function closeModal() {
    if (!modalEl) return;
    modalEl.hidden = true;
    modalEl.classList.remove('is-open');
    localStorage.setItem(SEEN_KEY, '1');
}

function setupModal() {
    if (!modalEl) return;
    if (localStorage.getItem(SEEN_KEY)) return;

    setTimeout(openModal, 30000);

    modalEl.querySelectorAll('[data-newsletter-close]').forEach((el) => {
        el.addEventListener('click', closeModal);
    });

    // "Do not show this window" — tick + close = same as the X button
    // semantically, but the user has explicitly said "never again", so
    // we close immediately on the change event without waiting for them
    // to find the close button afterwards.
    const optoutEl = modalEl.querySelector('[data-newsletter-optout]');
    if (optoutEl) {
        optoutEl.addEventListener('change', (e) => {
            if (e.target && e.target.checked) {
                localStorage.setItem(SEEN_KEY, '1');
                closeModal();
            }
        });
    }

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && !modalEl.hidden) closeModal();
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}
